import { render } from "./TiyoUpload.vue?vue&type=template&id=5be3fc12&scoped=true"
import script from "./TiyoUpload.vue?vue&type=script&lang=js"
export * from "./TiyoUpload.vue?vue&type=script&lang=js"

import "./TiyoUpload.vue?vue&type=style&index=0&id=5be3fc12&lang=scss&scoped=true"
import "./TiyoUpload.vue?vue&type=style&index=1&id=5be3fc12&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be3fc12"]])

export default __exports__